<template>
  <div
    class="homepage-grid"
    :class="{
      'single-report': hasChartAuthority !== hasRankAuthority,
      'shortcut-only': !hasChartAuthority && !hasRankAuthority,
    }"
  >
    <div v-if="hasChartAuthority" id="saleChart">
      <sale-chart></sale-chart>
    </div>
    <div v-if="hasRankAuthority" id="saleRank">
      <sale-rank></sale-rank>
    </div>
    <div id="shortCut" ref="shortCut">
      <short-cut @openShortcut="openShortcut"></short-cut>
    </div>
  </div>
</template>

<script>
import SaleChart from "@/components/home/SaleChart.vue";
import SaleRank from "@/components/home/SaleRank.vue";
import ShortCut from "@/components/home/ShortCut.vue";
import { AUTHORITIES_UPDATED_EVENT } from "@/funcs/localStorage";

export default {
  data() {
    return {
      chartAuthority: {},
      rankAuthority: {},
    };
  },
  components: {
    SaleChart,
    SaleRank,
    ShortCut,
  },
  computed: {
    hasChartAuthority() {
      return this.chartAuthority.IsList === true;
    },
    hasRankAuthority() {
      return this.rankAuthority.IsList === true;
    },
  },
  methods: {
    loadHomeAuthorities() {
      if (!window.localStorage["authorities"]) {
        this.chartAuthority = {};
        this.rankAuthority = {};
        return;
      }

      this.chartAuthority = this.$func.localStorage.getAuth(282);
      this.rankAuthority = this.$func.localStorage.getAuth(283);
    },
    openShortcut(toggle) {
      const shortCut = this.$refs.shortCut;
      if (toggle) {
        shortCut.classList.add("show");
      } else {
        shortCut.classList.remove("show");
      }
    },
  },
  created() {
    window.addEventListener(
      AUTHORITIES_UPDATED_EVENT,
      this.loadHomeAuthorities
    );
    this.loadHomeAuthorities();
    this.$api.businesses.getPart().then((data) => {
      let obj = {
        SalPriceName1: data.SalPriceName1,
        SalPriceName2: data.SalPriceName2,
        SalPriceName3: data.SalPriceName3,
        SalPriceName4: data.SalPriceName4,
        SalPriceName5: data.SalPriceName5,
        SalPriceName6: data.SalPriceName6,
      };
      localStorage.setItem("salPriceNames", JSON.stringify(obj));
    });
  },
  beforeUnmount() {
    window.removeEventListener(
      AUTHORITIES_UPDATED_EVENT,
      this.loadHomeAuthorities
    );
  },
};
</script>

<style lang="scss">
.homepage-grid {
  height: 100%;
  display: grid;
  grid-template-columns: minmax(0, 70fr) minmax(280px, 25fr);
  grid-template-rows: minmax(0, 1fr) auto;

  &.single-report,
  &.shortcut-only {
    grid-template-columns: minmax(0, 1fr);
  }

  &.single-report {
    #saleChart,
    #saleRank {
      grid-column: 1;
      grid-row: 1;
    }

    #saleRank {
      padding-right: 24px;
      padding-left: 24px;
    }

    #shortCut {
      grid-column: 1;
      grid-row: 2;
    }
  }

  &.shortcut-only {
    grid-template-rows: auto minmax(0, 1fr);

    #shortCut {
      grid-column: 1;
      grid-row: 1;
    }
  }
}
#saleChart {
  position: relative;
  grid-column: 1;
  grid-row: 1;
  min-width: 0;
  min-height: 0;
  padding: 0 24px;
  height: 100%;
  @media screen and (max-width: 991px) {
    height: 100%;
  }
}
#shortCut {
  grid-column: 1;
  grid-row: 2;
  min-width: 0;
  padding: 10px 24px 48px;
}
#saleRank {
  position: relative;
  grid-column: 2;
  grid-row: 1 / 3;
  min-width: 0;
  min-height: 0;
  padding: 0 24px 0 0;
  display: flex;
  flex-direction: column;
}

@media screen and (max-width: 1199px) {
  #shortCut {
    position: fixed;
    bottom: 0;
    left: 80px;
    z-index: 10;
    width: calc(100vw - 80px);
    padding: 0 24px 48px;
    transform: translateY(calc(100% - 18px));
    transition: transform 0.3s;
    &.show {
      transform: translateY(48px);
    }
  }
}
@media (max-width: 991px) {
  .container {
    flex-direction: column;
  }
  .homepage-grid {
    grid-template-columns: minmax(0, 1fr);
    grid-template-rows: repeat(2, minmax(0, 1fr));

    #saleChart {
      grid-column: 1;
      grid-row: 1;
    }

    #saleRank {
      grid-column: 1;
      grid-row: 2;
    }

    &.single-report {
      grid-template-rows: minmax(0, 1fr);

      #saleChart,
      #saleRank {
        grid-row: 1;
      }
    }

    &.shortcut-only {
      display: block;
    }
  }
  #saleChart {
    min-height: 0;
  }
  #saleRank {
    padding: 10px 24px 100px;
  }
  #shortCut {
    width: 100%;
    left: 0;
    padding: 0 16px 48px;
  }
}
</style>
